<template>
  <div prop="variable" class="sky-copy-feature wsp-line-height-28">
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>版本</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源产品版本：</label></div>
        <div class="wsp-display-flex-center">{{ variable.sourceProduct }}</div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-75">
          <el-select v-model="variable.targetProductId" filterable style="width: 100% !important;">
            <el-option v-for="(item, index) in productList" :key="index" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>功能</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源功能名称：</label></div>
        <div class="wsp-display-flex-center">{{ variable.featureName }}</div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标功能名称：</label></div>
        <div class="wsp-display-flex-center wsp-width-75">
          <el-input
            popper-class="sky-moudle-branch__autocomplete"
            :class="`${variable.targetFeatureName ? '' : 'input-validate-not-null'}`"
            style="width: 100% !important;"
            v-model="variable.targetFeatureName"
          >
          </el-input>
        </div>
      </div>
    </div>
    <!-- <div>
      <span>源功能名称：</span>
      <div>{{ variable.featureName }}</div>
      <span>目标功能名称：</span>
      <el-input
        popper-class="sky-moudle-branch__autocomplete"
        class="sky-copy-feature__select"
        v-model="variable.targetFeatureName"
      >
      </el-input>
    </div> -->
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>用例</strong>
    </div>
    <div style="height: 20vh;overflow-y: auto;">
      <div class="wsp-display-flex wsp-padding-left-12" v-for="(item, index) in variable.testCaseList" :key="index">
        <div class="wsp-width-49 wsp-display-flex">
          <div class="wsp-display-flex-center">
            <label>源用例名称【{{ index + 1 }}】:</label>
          </div>
          <div class="wsp-width-75 ">{{ item.sourceTestCaseName }}</div>
        </div>
        <div class="wsp-display-flex-center">
          <i class="el-icon-arrow-right" />
        </div>
        <div class="wsp-width-49 wsp-display-flex">
          <div class="wsp-display-flex-center">
            <label>目标用例名称：</label>
          </div>
          <div class="wsp-display-flex-center wsp-width-75">
            <el-input
              popper-class="sky-moudle-branch__autocomplete"
              :class="`${item.targetTestCaseName ? '' : 'input-validate-not-null'}`"
              class="sky-copy-feature__select"
              style="width: 100% !important;"
              v-model="item.targetTestCaseName"
            >
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div style="color: red;">{{ message }}</div>
    <div style="text-align: center;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { FEATURE_MNG, PRODUCT_MNG } from '@/api/apiModules'

export default {
  name: 'SkyCopyFeature',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    feature: {}
  },
  data() {
    return {
      loading: false,
      message: null,
      productList: [],
      variable: {
        featureName: null,
        targetFeatureName: null,
        sourceProduct: null,
        targetProductId: null,
        sourceFeatureId: null,
        testCaseList: []
      }
    }
  },
  created() {
    this.variable.featureName = this.feature.featureName
    this.variable.targetFeatureName = this.feature.featureName
    this.variable.sourceProduct = this.feature.productVersion
    this.variable.targetProductId = null
    this.variable.sourceFeatureId = this.feature.id

    let testCaseList = []
    if (this.feature.testCaseList) {
      this.feature.testCaseList.map(item => {
        let testCase = {
          sourceTestCaseId: item.testCaseId,
          sourceTestCaseName: item.testCaseName,
          targetTestCaseName: item.testCaseName
        }
        testCaseList.push(testCase)
      })
    }
    this.variable.testCaseList = testCaseList
  },
  mounted() {
    action(PRODUCT_MNG, 'findAllActive').then(response => {
      this.productList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
  },
  watch: {},
  methods: {
    isFill(item) {
      return item.targetTestCaseName
    },
    onConfirm() {
      if (this.variable && !this.variable.targetFeatureName) {
        this.message = '请输入新功能名称'
        return
      }
      if (this.variable && !this.variable.targetProductId) {
        this.message = '请选择目标产品版本'
        return
      }
      if (this.variable && this.variable.testCaseList.length > 0) {
        for (const item of this.variable.testCaseList) {
          if (!this.isFill(item)) {
            this.message = '请输入新用例名称'
            return
          }
        }
      }
      action(FEATURE_MNG, 'copySingleFeatureAndTestCase', this.variable)
        .then(response => {
          this.$emit('cb')
          this.$store.dispatch('OpenNotification', {
            message: '复制功能成功',
            type: 'success'
          })
        })
        .catch(e => {
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(copy-feature) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 220px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
